<template>
 <div>
    <communications-send-modal ref="replyModal" 
       :name="name" 
       :toUserId="senderId" 
       :subject="replySubject" 
       :body="replyBody"
       :isReply="true"
       :companyName="companyName"
       />
     <b-modal body-class="m-2" size="lg" ok-only id="comms-modal" :title="title">
       <b>{{ subject }}</b>
       <p>
         <vue-markdown class="mt-3" :source="body"/>
       </p>
      <i>sent {{ date | formatDatetime("MMMM dd, yyyy") }}</i>
      <template #modal-footer>
         <div class="d-flex w-100 flex-row-reverse">
            <button class="btn btn-secondary mx-1" @click="close()">Close</button>
            <button v-if="communicationType == 'private'" class="btn btn-primary mx-1" @click="reply">Reply</button>
         </div>
      </template>
     </b-modal>
  </div>
</template>

<script>

import CommunicationsSendModal from "./communications_send_modal.vue"
import axios from "axios"

export default {
  props: ["communication-id", "date", "subject", "direction", "body", "name", "communication-type", "investor-id", "sender-id", "company-name"],
  methods: {
    async show(communicationId) {
      // rendering order oddness prevents us from using the property in this method
      this.$bvModal.show("comms-modal")
      if ( communicationId ) {
        const resp = await axios.post("/communications/mark_read", { communication_id: communicationId })
        if ( resp.data.read ) {
          this.$emit("mark-read", communicationId)
          decrementUnreadMessageCount()
        }
      }
    },
    close() { 
      this.$bvModal.hide("comms-modal")
    },
    reply() { 
      this.$refs.replyModal.show()
      this.$bvModal.hide("comms-modal")
    }
  },
  computed: {
    title() {
      if ( this.communicationType == "invitation" ) {
        return "Initial invitation"
      } else {
        return `Message ${this.direction} ${this.name}`
      }
    },
    replySubject() {
      if ( !this.subject ) return null
      if ( this.subject.startsWith("re: ") )
         return this.subject
      return "re: " + this.subject
    },
    replyBody() { 
      if ( !this.body ) return null
      return "<br>\n" + this.body.split("\n").map(l => "> " + l).join("\n") 
    }
  },
  components: { CommunicationsSendModal }
}
</script>
